import React from 'react';
import { BrainIcon, GlobeIcon, InstagramIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-white py-14 md:py-16" data-id="element-103" data-mp="3ggarlxr3gh6i">
      <div className="mx-auto w-full max-w-narrow px-5 text-center md:px-8" data-id="element-104" data-mp="3gh3ng3oilm9v">
        <p className="inline-flex items-center gap-2 font-display text-lg font-extrabold uppercase tracking-[0.14em] text-blue-600" data-id="element-105" data-mp="32pp3nums9h1r">
          <BrainIcon className="h-5 w-5" aria-hidden="true" data-id="element-106" data-mp="3ufa4k858v7mu" />
          MiMejorVersión™
        </p>

        <p className="mx-auto mt-5 max-w-xl text-blue-900/75" data-id="element-107" data-mp="38h2z36jh6hs">
          El sistema N°1 para estimulación cognitiva en adultos mayores de Argentina.
        </p>
        <p className="mx-auto mt-3 max-w-xl font-display text-lg font-bold italic tracking-tight text-ink" data-id="element-108" data-mp="3le2l2w7e0bct">
          Porque envejecer bien no debería costarte incertidumbre.
        </p>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-7 gap-y-3 text-blue-900/75" data-id="element-109" data-mp="29xm0kogz74j3">
          <li data-id="element-110" data-mp="2ezl35w4w5xez">
            <a href="mailto:soporte@mimejorversionar.com" className="inline-flex items-center gap-2 transition-colors duration-150 ease-calm hover:text-blue-600" data-id="element-111" data-mp="2evx8gtnpn4yo">
              <MailIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-112" data-mp="3gbqyshkqgpby" />
              soporte@mimejorversionar.com
            </a>
          </li>
          <li data-id="element-113" data-mp="3q8n0o4g4md7j">
            
          </li>
          <li className="inline-flex items-center gap-2" data-id="element-114" data-mp="3q7u0xnfl4nyw">
            <InstagramIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-115" data-mp="82qsptubnvu9" />
            @mimejorversion.ar
          </li>
        </ul>

        <p className="mt-10 border-t border-blue-100 pt-6 text-sm text-blue-900/50" data-id="element-116" data-mp="335s7ezi7fff">
          © MiMejorVersión™ 2026. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}